import React from "react";

function Testimonial() {
  return (
    <section className="overflow-hidden bg-[#191e1c] section-spacing">
      <div className="section-container">
        <div>
          {/* Label */}
          <p className="font-jakarta text-[11px] font-medium tracking-[0.34em] text-[var(--mint-green)] sm:text-[12px] uppercase mb-4">
            THE FINVERSE COMMITMENT
          </p>

          {/* Company Statement */}
          <blockquote className="font-bricolage text-[22px] sm:text-[28px] md:text-[32px] lg:text-[36px] font-normal leading-[1.35] tracking-[-0.5px] text-[#f4f7f5] text-balance">
            “Finverse is built to accelerate India&apos;s credit distribution — connecting ambitious DSA partners, verified borrowers, and 36+ leading institutional lenders with radical speed, zero paperwork friction, and guaranteed T+7 weekly payouts.”
          </blockquote>

          {/* Attribution */}
          <p className="mt-6 font-jakarta text-[11px] font-medium uppercase tracking-[0.32em] text-[#788580] sm:mt-8 sm:text-[12px]">
            PARTHV CAPVERSE ADVISORY PRIVATE LIMITED · EMPOWERING 2,800+ PARTNERS ACROSS INDIA
          </p>
        </div>
      </div>
    </section>
  );
}

export default Testimonial;
